import styles from "../../HeaderDesktop.module.scss";
import Button from "@Components/Button";
import Modal from "@Components/Modal";
import AmberlocalStorage from "@Utils/AmberlocalStorage";
import wrapperHOC from "@Utils/wrapperHOC";
import { useMemo, useState } from "react";

const AgentViewTour = ({ internalUser = false, parentPageName = "" }: any) => {
  const shouldShow = useMemo(() => {
    const month = new Date().getMonth() + 1;
    const year = new Date().getFullYear();
    // Don't show after october 2024
    if (month > 9 || year > 2024) {
      return false;
    }

    let savedData = { count: 0, closeTime: 0 };
    try {
      savedData = JSON.parse(AmberlocalStorage.getItem("agentviewtour") || "{}") || {};
    } catch (e) {
      console.log("error", e);
    }

    if (
      savedData.count &&
      savedData.closeTime &&
      (savedData.count >= 3 || new Date().getTime() - savedData.closeTime < 86400000) // closed in last 24hrs or close three times
    ) {
      return false;
    }

    return true;
  }, []);

  const [show, setShow] = useState(shouldShow);

  const closeAgentTour = () => {
    const data = { count: 1, closeTime: new Date().getTime() };
    try {
      const savedData = JSON.parse(AmberlocalStorage.getItem("agentviewtour") || "{}");
      if (savedData && savedData.count) {
        data.count = savedData.count + 1;
      }
    } catch (e) {
      console.log("error", e);
    }
    localStorage.setItem("agentviewtour", JSON.stringify(data));
    setShow(false);
  };

  return (
    <>
      {internalUser &&
        __CLIENT__ &&
        show &&
        ["search_page", "inventory_page"].includes(parentPageName) && (
          <Modal
            hideModal={() => null}
            coverClassName={styles.modalClass}
            size="fitContent"
            animation="noAnimate"
            hideCloseButton
          >
            <div className={styles.dropdownContainer}>
              <div>Click here to view as Agent</div>
              <Button
                className={styles.okayBtn}
                variant="primary"
                size="sm"
                onClick={closeAgentTour}
              >
                Okay
              </Button>
            </div>
          </Modal>
        )}
    </>
  );
};

export default wrapperHOC(AgentViewTour, {
  componentName: "HeaderDesktop-AgentViewTour",
  showForChina: true,
});
